(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__announcementTooltipsInit) return;
    window.__announcementTooltipsInit = true;

    function onDocClick(e) {
      var trigger = e.target.closest('.announcement-bar__tooltip-trigger');
      if (trigger) {
        var group = trigger.closest('.announcement-bar__tooltip-group');
        if (group) {
          var isVisible = group.classList.toggle('announcement-bar__tooltip-visible');
          trigger.setAttribute('aria-expanded', isVisible);
        }
        return;
      }
      document.querySelectorAll('.announcement-bar__tooltip-group.announcement-bar__tooltip-visible').forEach(function (group) {
        group.classList.remove('announcement-bar__tooltip-visible');
        var t = group.querySelector('.announcement-bar__tooltip-trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        document.addEventListener('click', onDocClick);
      });
    } else {
      document.addEventListener('click', onDocClick);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (() => {
    const gridSelector = '.js-plp-grid';
    const toggleSelector = '.js-toggle-filter-column';

    if (!window.filterColumnToggleController) {
      window.filterColumnToggleController = {};
    }

    const syncFilterColumnState = (button) => {
      const columnId = button.getAttribute('aria-controls');
      const column = columnId ? document.getElementById(columnId) : null;

      if (!column) return;

      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const toggleText = button.querySelector('.js-toggle-filter-column-text');
      const grid = document.querySelector(gridSelector);

      column.hidden = !isExpanded;

      if (toggleText) {
        toggleText.textContent = isExpanded ? button.dataset.hideLabel : button.dataset.showLabel;
      }

      if (!grid) return;

      if (isExpanded) {
        grid.style.removeProperty('min-width');
      } else {
        grid.style.minWidth = '100%';
      }
    };

    const syncAllFilterColumns = () => {
      document.querySelectorAll(toggleSelector).forEach(syncFilterColumnState);
    };

    window.filterColumnToggleController.sync = syncAllFilterColumns;

    if (window.filterColumnToggleController.initialized) {
      syncAllFilterColumns();
      return;
    }

    window.filterColumnToggleController.initialized = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest(toggleSelector);

      if (!button) return;

      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isExpanded));
      syncFilterColumnState(button);
    });

    document.addEventListener('DOMContentLoaded', syncAllFilterColumns);
    document.addEventListener('shopify:section:load', syncAllFilterColumns);
    syncAllFilterColumns();
  })();
  } catch(e) { console.error(e); }
})();

})();
